class LDMCalculator {
    constructor(section) {
        this.section = section;
        this.ldmForm = section.querySelector('.ldm-calculator__form');
        this.ldmLengthInput = section.querySelector('.ldmLengthInput');
        this.ldmWidthInput = section.querySelector('.ldmWidthInput');
        this.ldmQuantityInput = section.querySelector('.ldmQuantityInput');
        this.ldmBtn = section.querySelector('.ldm-calculator__btn');
        this.ldmCtaBtn = section.querySelector('.ldm-calculator__cta');
        this.ldmResultsBlock = section.querySelector('.ldm-calculator__results');
        this.ldmResult = this.ldmResultsBlock.querySelector('.ldm-result');
        this.ldm = '';

        this.ldmForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const l = this.getElementValue(this.ldmLengthInput);
            const w = this.getElementValue(this.ldmWidthInput);
            const q = this.getElementValue(this.ldmQuantityInput);

            if (isNaN(l) || isNaN(w) || isNaN(q)) {
                alert('Please enter valid numerical values in all fields.');
                return;
            }

            this.ldm = this.calculateLoadingMetre(l, w, q);
            this.showResult(this.ldmResultsBlock, this.ldmBtn, this.ldmCtaBtn, this.ldmResult, this.ldm);
        });

        this.ldmForm.addEventListener('input', (e) => {
            e.preventDefault();
            this.clearResults(this.ldmResultsBlock, this.ldmBtn, this.ldmCtaBtn);
            this.ldm = 0;
        });
    }

    getElementValue(el) {
        return parseFloat(el.value);
    }

    showResult(block, button, cta, element, result) {
        block.style.opacity = 1;
        block.style.visibility = 'visible';
        button.setAttribute('disabled', '');
        button.value = button.getAttribute('data-recalculate');
        cta.style.display = 'inline-flex';
        element.innerHTML = `${result}`;
    }

    clearResults(block, button, cta) {
        block.style.opacity = 0;
        block.style.visibility = 'hidden';
        button.removeAttribute('disabled');
        cta.style.display = 'none';
    }

    calculateLoadingMetre(length, width, quantity, number = 2.4) {
        return +((((length / 100) * (width / 100)) / number) * quantity).toFixed(1);
    }
}

export default LDMCalculator;


// WEBPACK FOOTER //
// ./scripts/modules/ldmCalc.js